import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LinkContainer } from 'react-router-bootstrap';


import {
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  Collapse,
  Container,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

// Local Deps
import lock from '../Auth/lock';
import { isLoggedIn } from '../Auth/utils';
import './TopNav.scss';
import TopNavAvatar from './TopNavAvatar'
import msgs from '../../config/messages';
import {
  homeRoute,
  facebookRoute,
  youtubeRoute,
  twitterRoute,
  toolingLocationListRoute,
  aboutRoute,
  iconfaqsRoute,
  helpRoute,
  contactRoute,
  solicitationsSearchRoute,
  registrationRoute,
  supplierCapabilitiesRoute,
  codeDefinitionsRoute,
  relNotesRoute,
  newslettersRoute,
} from '../../config/navigation/routes';
import { checkIfAuthIsValid } from '../../utils/authUtils';
import Logo from '../../images/icon_home_logo.png';
import facebook from '../../images/facebook.png';
// import instagram from '../../images/instagram.png';
import youtube from '../../images/youtube.png';
import twitter from '../../images/twitter.png';


export default class TopNav extends Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    auth: PropTypes.shape({
      jwtToken: PropTypes.string,
      expiration: PropTypes.number,
      permissions: PropTypes.array,
    }).isRequired,
    className: PropTypes.string,
    // originalOrgId: PropTypes.string,
    orgInfo: PropTypes.object,
    newMessage: PropTypes.bool.isRequired,
    newMessageCount: PropTypes.number.isRequired,

  };

  static defaultProps = {
    className: '',
    // originalOrgId: null,
    orgInfo: null,
  };

  static initialState = {
    isOpen: false,
    visible: false,
    setTimeoutId: null,
  };

  state = TopNav.initialState;

  _toggle = isOpen => {
    this.setState({
      isOpen,
    });
  };

  render() {
    const {
      auth,
      login,
      logout,
      className,
      // originalOrgId,
      orgInfo,
      newMessage,
      newMessageCount,
    } = this.props;

    const isAuthenticated = checkIfAuthIsValid(auth);
    const avatar = <TopNavAvatar
      auth={auth}
      login={login}
      logout={logout}
      newMessage={newMessage}
      newMessageCount={newMessageCount}
      orgInfo={orgInfo}
      toggle={this._toggle}
    />
    return (
      <div className={`nf-top-nav ${className}`}>
        <Navbar data-pills expand="lg">
          <Container>
            <LinkContainer to={homeRoute} isActive={() => false}>
              <NavbarBrand>
                <img src={Logo} alt="Icon" className="nf-icon-logo" />
                <p className="navbar-brand-text">{msgs.TopNav.brandText}</p>
              </NavbarBrand>
            </LinkContainer>

            <div className="nf-social-links">
              <a href={facebookRoute} target="_blank">
                <img
                  src={facebook}
                  alt="Visit us on Facebook"
                  title="Visit us on Facebook"
                  className="nf-social"
                />
              </a>
              {/*                
                <a href={instagramRoute} target="_blank"><img src={instagram} alt="Visit us on Instagram" title="Visit us on Instagram" className="nf-social" /></a>
*/}
              <a href={youtubeRoute} target="_blank">
                <img
                  src={youtube}
                  alt="Visit us on YouTube"
                  title="Visit us on YouTube"
                  className="nf-social"
                />
              </a>
              <a href={twitterRoute} target="_blank">
                <img
                  src={twitter}
                  alt="Visit us on Twitter"
                  title="Visit us on Twitter"
                  className="nf-social"
                />
              </a>
            </div>

            {/* Display here when navbar is not expanded */}
            {isAuthenticated && (
              <Nav id="avatarMenu1" className="nav--last">
                {avatar}
              </Nav>
            )}

            <NavbarToggler onClick={() => this._toggle(!this.state.isOpen)}>
              <i className="fa fa-bars" />
            </NavbarToggler>
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav>
                {isAuthenticated && (
                  <LinkContainer
                    to={solicitationsSearchRoute}
                    isActive={() => false}
                  >
                    <NavItem onClick={() => this._toggle(false)}>
                      {msgs.TopNav.item4}
                    </NavItem>
                  </LinkContainer>
                )}
                {isAuthenticated && (
                  <LinkContainer
                    to={toolingLocationListRoute}
                    isActive={() => false}
                  >
                    <NavItem onClick={() => this._toggle(false)}>
                      {msgs.TopNav.item1}
                    </NavItem>
                  </LinkContainer>
                )}
                {/* {isAuthenticated && (
                  <LinkContainer
                    to={procurementHistoryRoute}
                    isActive={() => false}
                  >
                    <NavItem onClick={() => this._toggle(false)}>
                      {msgs.TopNav.procurementHistory}
                    </NavItem>
                  </LinkContainer>
                )} */}
                {isAuthenticated && (
                  <LinkContainer
                    to={supplierCapabilitiesRoute}
                    isActive={() => false}
                  >
                    <NavItem onClick={() => this._toggle(false)}>
                      {msgs.TopNav.item5}
                    </NavItem>
                  </LinkContainer>
                )}
                <LinkContainer to={aboutRoute} isActive={() => false}>
                  <NavItem onClick={() => this._toggle(false)}>
                    {msgs.TopNav.item2}
                  </NavItem>
                </LinkContainer>
                <LinkContainer to={contactRoute} isActive={() => false}>
                  <NavItem onClick={() => this._toggle(false)}>
                    {msgs.TopNav.item3}
                  </NavItem>
                </LinkContainer>

                <UncontrolledDropdown nav inNavbar className="nav-item">
                  <DropdownToggle nav>
                    <span className="dropdown-support-menu">
                      {msgs.TopNav.supportDropdown.support}
                    </span>
                  </DropdownToggle>

                  <DropdownMenu right>
                    <LinkContainer
                      to={iconfaqsRoute}
                      isActive={() => false}
                      onClick={() => this._toggle(false)}
                    >
                      <DropdownItem left>
                        {msgs.TopNav.supportDropdown.iconfaqs}
                      </DropdownItem>
                    </LinkContainer>
                    <LinkContainer
                      to={helpRoute}
                      isActive={() => false}
                      onClick={() => this._toggle(false)}
                    >
                      <DropdownItem left>
                        {msgs.TopNav.supportDropdown.help}
                      </DropdownItem>
                    </LinkContainer>

                    <LinkContainer
                      to={codeDefinitionsRoute}
                      isActive={() => false}
                      onClick={() => this._toggle(false)}
                    >
                      <DropdownItem left>
                        {msgs.TopNav.supportDropdown.cdHelp}
                      </DropdownItem>
                    </LinkContainer>
                    <LinkContainer
                      to={relNotesRoute}
                      isActive={() => false}
                      onClick={() => this._toggle(false)}
                    >
                      <DropdownItem left>
                        {msgs.TopNav.supportDropdown.relNotesHelp}
                      </DropdownItem>
                    </LinkContainer>
                    <LinkContainer
                      to={newslettersRoute}
                      isActive={() => false}
                      onClick={() => this._toggle(false)}
                    >
                      <DropdownItem left>
                        {msgs.TopNav.supportDropdown.newslettersHelp}
                      </DropdownItem>
                    </LinkContainer>
                  </DropdownMenu>
                </UncontrolledDropdown>

                {!isAuthenticated && (
                  <LinkContainer to='#' isActive={() => false}>
                    <NavItem onClick={() => {
                      if (isLoggedIn(auth)) {
                        logout();
                      } else {
                        lock.show();
                        lock.authorizedPromise.then(jwtToken => {
                          login(jwtToken);
                        });
                      }
                    }}
                    >
                      {isLoggedIn(auth) ? 'Logout' : 'Login'}
                    </NavItem>
                  </LinkContainer>
                )}

                {isLoggedIn(auth) ? null : (
                  <LinkContainer
                    to={registrationRoute}
                    isActive={() => false}
                    onClick={() => this._toggle(false)}
                  >
                    <NavItem>
                      {msgs.TopNav.userDropdown.register}
                    </NavItem>
                  </LinkContainer>
                )}
              </Nav>

            </Collapse>
            {/* Display here when navbar is expanded */}
            {isAuthenticated && (
              <Nav id="avatarMenu2" className="nav--last">
                {avatar}
              </Nav>
            )}

          </Container>
        </Navbar>
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TopNav/TopNav.jsx